import { Component, OnInit } from '@angular/core';
import { NgxNavigationWithDataComponent } from 'ngx-navigation-with-data';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FilesService } from '../../services/files.service';
import {TrackingService} from '../../services/tracking.service';
import { Observable } from 'rxjs';
import * as firebase from 'firebase/app';
import { concatMap, map } from 'rxjs/operators';
import {Track} from '../../interfaces/track';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { ImageTrack } from 'src/app/interfaces/image-track';


@Component({
  selector: 'app-tracking-edit',
  templateUrl: './tracking-edit.component.html',
  styleUrls: ['./tracking-edit.component.sass']
})
export class TrackingEditComponent implements OnInit {
  public track:Observable<Track|null>;
  public id:string;
  public userId: string = "_";
  public images:Observable<ImageTrack[]>;


  public archivoForm = new FormGroup({
    archivo: new FormControl(null, Validators.required),
  });
  
  public mensajeArchivo = 'No hay un archivo seleccionado';
  public datosFormulario = new FormData();
  public nombreArchivo = '';
  public porcentaje = 0;
  public finalizado = false;



  constructor(
    public navCtrl: NgxNavigationWithDataComponent,
    private firebaseStorage: FilesService,
    private ts: TrackingService,
    private us: AuthService
    ) {
      this.id = this.navCtrl.get('id');
      this.track = this.ts.getTracking(this.id).valueChanges().pipe(map((t: (Track | null)) => {
          this.validView(t)
          return t;
      }));
     us.user.pipe(map(u=> u?.id ?? "")).subscribe(i=>{this.userId = i});
     this.images = ts.listImageTracking(this.id).valueChanges()
      
  
     }

  ngOnInit(): void {  }

  private validView(value:Track|null){ 
    if(value == null){ this.navCtrl.navigate('error', {status:"204"});}
  }


  //Evento que se gatilla cuando el input de tipo archivo cambia
  public cambioArchivo(event:any) {
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.mensajeArchivo = `Archivo preparado: ${event.target.files[i].name}`;
        this.nombreArchivo = event.target.files[i].name;
        this.datosFormulario.delete('archivo');
        this.datosFormulario.append('archivo', event.target.files[i], event.target.files[i].name)
      }
    } else {
      this.nombreArchivo = "";
      this.mensajeArchivo = 'No hay un archivo seleccionado';
    }
  }

  //Sube el archivo a Cloud Storage
  public subirArchivo() {
    if(this.nombreArchivo.trim().length > 0){
      this.finalizado = false;
      let archivo = this.datosFormulario.get('archivo');
      let referencia = this.firebaseStorage.refernceFile(this.id + "/" + this.nombreArchivo);
      let tarea = this.firebaseStorage.uploadFile(this.id, this.nombreArchivo, archivo);

      //Cambia el porcentaje
      tarea.percentageChanges().subscribe(porcentaje => {
        this.porcentaje = Math.round(porcentaje ?? 0);
        if (this.porcentaje == 100) {
          this.finalizado = true;
          //list

          //no funciona
          referencia.getDownloadURL().subscribe(u =>{
            this.ts.newTrackingImage(this.id, {name:this.nombreArchivo, ownerId:this.userId, url:u as string})
          });
         
        }
      });
  }

}







}
